var vendorDocumentsArray = [];
var eachDocImageValid = [];
var mandatoryDocsId = [];
var documentIdArray = [];
var vendorAWSURL = "";

import { getImageUrl, getVendorBusinessImageUrl } from "../helpers/mediaUrl";



const isBusinessPhotoDoc = (documentName) => {
  if (!documentName) return false;
  const lower = documentName.toLowerCase();
  return lower.includes("business photo") || lower.includes("business image");
};

export default class Vendor_upload_documents {
  constructor() {
    this.productServicesListingPage = $(".product-services-listing-page");
    this.uploadPrevBtn = $("#uploadPrevBtn");
    this.uploadDocsSubmitBtn = $(".uploadDocsSubmitBtn");
    this.uploadDocuments_page5 = $(".vendorUploadDocuments");
    this.listingPageSmtBtn = $("#listingPageSmtBtn");
    this.Products_Services_page4 = $(".Products-Services-page4"); //not used ?

    // Registering Events
    this.bindEvents();
  }

  bindEvents = () => {
    this.get_Vendor_Summary();
    //
    this.listingPageSmtBtn.on("click", this.getRequiredVendorDocuments);
    this.uploadDocsSubmitBtn.on("click", this.doDocumentValidation);
    this.uploadPrevBtn.on("click", this.UploadDocPagePrevAction);
  };
  get_Vendor_Summary = () => {
    $.ajax({
      type: "GET",
      url: baseURL + "api/vendor/getVendorDetails",
      headers: { Authorization: X_API_KEY },
      success: (res) => {
        console.log("Vendor API response:", res);

        this.vendorID = res.vendor?.Vendor_ID || res.Vendor_ID;

        if (!this.vendorID) {
          console.error("Vendor_ID missing!");
          return;
        }

        console.log("Vendor ID set to:", this.vendorID);

        vendorAWSURL = getVendorBusinessImageUrl(res.Image_URL, 1);

        this.getRequiredVendorDocuments();
      },
    });
  };

  getRequiredVendorDocuments = () => {
    if (!this.vendorID) {
      console.error("Cannot fetch documents - vendorID not set");
      return;
    }

    $.ajax({
      type: "GET",
      url:
        baseURL +
        "api/vendor/RequiredVendorDocuments?Vendor_ID=" +
        this.vendorID,
      headers: { Authorization: X_API_KEY },

      success: this.showRequiredDocuments,
    });
  };
  // To go to Previous Page (Product Listing)
  UploadDocPagePrevAction = (e) => {
    e.preventDefault();
    //
    this.productServicesListingPage.removeClass("d-none");
    this.uploadDocuments_page5.addClass("d-none");
    this.formstep5.removeClass("current-item");
    this.formstep4.addClass("current-item");
  };

  // To validate if all manditory document images are submitted
  doDocumentValidation = (e) => {
    //
    //
    //
    //

    e.preventDefault();
    var mandatoryDocsImagealid = true;
    mandatoryDocsId.forEach((element) => {
      //

      const docFileInput = document.getElementById(element);

      if (!(docFileInput.files[0] === undefined)) {
        if (eachDocImageValid[element] == false) {
          //
          const docFileInputPrev = document.getElementsByClassName(element);
          docFileInputPrev[1].innerHTML = "Please select an image file";
          mandatoryDocsImagealid = false; //Removed for Servicing
        }
      }
    });

    if (mandatoryDocsImagealid) {
      //
      this.Submit_VendorDocuments();
    }
  };

  // Vendor Documents submit function
  Submit_VendorDocuments = async () => {
    if (!this.vendorID) {
      console.error("VendorID not set!");
      return;
    }

    const formData = new FormData();

    for (const element of documentIdArray) {
      const file = document.getElementById(element).files[0];
      if (file) {
        formData.append(element, file);
      }
    }

    formData.append("Vendor_ID", this.vendorID);

    console.log([...formData.entries()]); // DEBUG

    const res = await fetch(baseURL + "api/vendor/uploadDocuments", {
      method: "POST",
      headers: { Authorization: X_API_KEY },
      body: formData,
    });

    const data = await res.json();
    console.log("UPLOAD RESPONSE:", data);

    if (res.ok) {
      this.getRequiredVendorDocuments();
    } else {
      console.error("Document upload failed:", data);
    }
  };

  // To load Summary page using vendor Id
  vendorDataID = (res) => {
    //
    // var Vendor_ID = "67ccb451-4497-11e9-b548-778fd1e3dff0";
    var Vendor_ID = res.vendor["Vendor_ID"];
    //
    //window.location.replace(baseURL + "Vendor_summary/index/" + Vendor_ID);

    //TO GO TO NEXT PAGE
    //window.location.replace(baseURL + "Vendor_summary/index/" + Vendor_ID);
  };

  // To integrate the documents on the page
  showRequiredDocuments = (res) => {
    $("#vendorDocBox").empty();
    //
    var mandatoryDocsCount = 0;
    console.log("DOCUMENT API RESPONSE:", res);
    documentIdArray = [];
    res.forEach((element) => {
      console.log(
        "Processing document:",
        element.Document_ID,
        "has Document_URL:",
        element.Document_URL,
      );
      if (element.Mandatory_flag == 1) {
        mandatoryDocsId[mandatoryDocsCount] = element.Document_ID;
        mandatoryDocsCount++;
      }
      var mandatorylabel = element.Mandatory_flag == 1 ? "&nbsp*" : "";
      var nextDocument = `<div class="row mb-3">
                          <div><label class="form-label">${element.Document_Name}</label><label class="text-danger">${mandatorylabel}</label></div>
                          <input type="file" class="form-control inputVendorDocument" id="${element.Document_ID}" accept=".jpg,.jpeg,.png,.webp,.pdf" name="inpFile" aria-describedby="" value='doc-preview-${element.Document_ID}'>
                          <br>
                          <div>
                          <img src="" alt="" id="doc-preview-${element.Document_ID}" class="${element.Document_ID}" width="220px" height="auto" value='${element.Document_Name}'>
                          <div class="docImageError text-danger ${element.Document_ID}"></div></div>
                          <br>
                          </div>`;
      $("#vendorDocBox").append(nextDocument);
      const docFileInput = document.getElementById(element.Document_ID);
      docFileInput.addEventListener("change", this.isDocumentImmage);
      eachDocImageValid[element.Document_ID] = false;
      documentIdArray.push(element.Document_ID);
      if (element.Document_URL) {
        console.log(
          "Calling insertDocImg with:",
          element.Document_ID,
          element.Document_URL,
        );
        this.insertDocImg(element.Document_ID, element.Document_URL);
      } else if (isBusinessPhotoDoc(element.Document_Name)) {
        this.insertDocImg(element.Document_ID, vendorAWSURL);
      }
      // this.insertDocImg(element.Document_ID, "Vendor/0001_default/Document Images/ID Proof.jpg");
    });
  };

  insertDocImg = (imgTagClassName, path) => {
    const el = document.getElementsByClassName(imgTagClassName)[0];
    if (!el || !path) return;
    el.src = getImageUrl(path);
  };
  // Validation to check if the Document is in image form
  isDocumentImmage = (e) => {
    //
    //
    var docImagePreview = e.target.id;
    const docFileInputPrev = document.getElementsByClassName(docImagePreview);
    //
    //
    docFileInputPrev[0].src = "";
    eachDocImageValid[docImagePreview] = false;

    //
    if (!e.target.files.length) {
      return;
    }

    var fileExpression = /.*\.(jpg|jpeg|png|webp|pdf|JPG|JPEG|PNG|WEBP|PDF)$/;
    if (!e.target.files[0]) {
    } else {
      if (
        !e.target.files[0]["name"].match(fileExpression) ||
        !e.target.files[0]["name"]
      ) {
        docFileInputPrev[1].innerHTML =
          "Please select JPG, JPEG, PNG, WEBP or PDF file";
      } else if (e.target.files[0]["size"] > 5 * 1024 * 1024) {
        docFileInputPrev[1].innerHTML = "Document should be less than 5mb";
      } else {
        //
        eachDocImageValid[docImagePreview] = true;

        docFileInputPrev[1].innerHTML = "";

        if (
          e.target.files[0] &&
          (e.target.files[0].type || "").toLowerCase().startsWith("image/")
        ) {
          const reader = new FileReader();

          reader.addEventListener("load", function () {
            // Storing image in Preview
            docFileInputPrev[0].src = this.result;
          });

          reader.readAsDataURL(e.target.files[0]);
        }
      }
    }
  };
}

